module.exports = __webpack_public_path__ + "static/logo-colored-ba0c3857d8c3068f32c2781073415bd3.svg";